import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

const Row = ({ label, children }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
    <Typography variant="caption" sx={{ color: '#888', fontSize: 11, width: 56, flexShrink: 0 }}>
      {label}
    </Typography>
    {children}
  </Box>
);

const DimInput = ({ value, onChange }) => {
  const isAuto = !value || value === 'auto';
  const num = isAuto ? '' : parseFloat(value) || '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flex: 1 }}>
      <TextField
        size="small"
        placeholder="auto"
        value={num}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === '' ? 'auto' : v + 'px');
        }}
        inputProps={{ min: 0, style: { fontSize: 12, padding: '3px 6px', width: 64 } }}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1 } }}
      />
      <Typography variant="caption" sx={{ color: '#aaa', fontSize: 10 }}>px</Typography>
    </Box>
  );
};

const SizePanel = ({ styles = {}, onChange }) => {
  const get = (prop) => styles[prop] || '';

  return (
    <Box>
      <Row label="Width">
        <DimInput value={get('width')} onChange={(v) => onChange('width', v)} />
      </Row>
      <Row label="Height">
        <DimInput value={get('height')} onChange={(v) => onChange('height', v)} />
      </Row>
      <Row label="Min W">
        <DimInput value={get('minWidth')} onChange={(v) => onChange('minWidth', v)} />
      </Row>
      <Row label="Max W">
        <DimInput value={get('maxWidth')} onChange={(v) => onChange('maxWidth', v)} />
      </Row>
    </Box>
  );
};

export default SizePanel;
